import { Marketplaces } from 'src/types/Marketplaces';

export interface Guidelines {
  conditionsOfUse: string,
  privacyNotice: string,
  programPolicies: string,
  conduct: string,
  agreement: string,
}

export const communityLinks: Record<Marketplaces, Guidelines> = {
  [Marketplaces.australia]: {
    conditionsOfUse: 'https://www.amazon.com.au/gp/help/customer/display.html?nodeId=508088&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.com.au/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    programPolicies: 'https://sellercentral.amazon.com.au/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com.au/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.au/help/hub/reference/G1791',
  },
  [Marketplaces.belgium]: {
    conditionsOfUse: 'https://www.amazon.com.be/-/en/gp/help/customer/display.html?ref_=hp_left_v4_sib&nodeId=GLSBYFE9MGKKQXXM',
    privacyNotice: 'https://www.amazon.com.be/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    programPolicies: 'https://sellercentral.amazon.com.be/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com.be/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.be/help/hub/reference/G201190440',
  },
  [Marketplaces.brazil]: {
    conditionsOfUse: 'https://www.amazon.com.br/gp/help/customer/display.html/ref=footer_cou?ie=UTF8&nodeId=201283910',
    privacyNotice: 'https://www.amazon.com.br/gp/help/customer/display.html?nodeId=201283950&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.com.br/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com.br/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.br/help/hub/reference/G1791',
  },
  [Marketplaces.canada]: {
    conditionsOfUse: 'https://www.amazon.ca/gp/help/customer/display.html?nodeId=918816&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.ca/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    programPolicies: 'https://sellercentral.amazon.ca/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.ca/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.ca/help/hub/reference/G1791',
  },
  [Marketplaces.egypt]: {
    conditionsOfUse: 'https://www.amazon.eg/-/en/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.eg/-/en/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.eg/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.eg/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.eg/help/hub/reference/G201190440',
  },
  [Marketplaces.france]: {
    conditionsOfUse: 'https://www.amazon.fr/gp/help/customer/display.html/?ie=UTF8&nodeId=548524',
    privacyNotice: 'https://www.amazon.fr/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.fr/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.fr/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.fr/help/hub/reference/G201190440',
  },
  [Marketplaces.germany]: {
    conditionsOfUse: 'https://www.amazon.de/gp/help/customer/display.html/?ie=UTF8&nodeId=505048',
    privacyNotice: 'https://www.amazon.de/-/en/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.de/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.de/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.de/help/hub/reference/G201190440',
  },
  [Marketplaces.india]: {
    conditionsOfUse: 'https://www.amazon.in/gp/help/customer/display.html?nodeId=200545940&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.in/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    programPolicies: 'https://sellercentral.amazon.in/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.in/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.in/help/hub/reference/G201190440',
  },
  [Marketplaces.italy]: {
    conditionsOfUse: 'https://www.amazon.it/gp/help/customer/display.html/?ie=UTF8&nodeId=200545940',
    privacyNotice: 'https://www.amazon.it/gp/help/customer/display.html?nodeId=200545460&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.it/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.it/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.it/help/hub/reference/G201190440',
  },
  [Marketplaces.japan]: {
    conditionsOfUse: 'https://www.amazon.co.jp/gp/help/customer/display.html?nodeId=643006',
    privacyNotice: 'https://www.amazon.co.jp/-/en/gp/help/customer/display.html?nodeId=643000&ref_=footer_privacy&language=ja_JP',
    programPolicies: 'https://sellercentral.amazon.co.jp/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.co.jp/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.co.jp/help/hub/reference/G1791',
  },
  [Marketplaces.mexico]: {
    conditionsOfUse: 'https://www.amazon.com.mx/gp/help/customer/display.html?ie=UTF8&nodeId=508088',
    privacyNotice: 'https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.com.mx/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com.mx/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.mx/help/hub/reference/G1791',
  },
  [Marketplaces.netherlands]: {
    conditionsOfUse: 'https://www.amazon.nl/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.nl/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.nl/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.nl/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.nl/help/hub/reference/G201190440',
  },
  [Marketplaces.poland]: {
    conditionsOfUse: 'https://www.amazon.pl/gp/help/customer/display.html?nodeId=GLSBYFE9MGKKQXXM&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.pl/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.pl/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.pl/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.pl/help/hub/reference/G201190440',
  },
  [Marketplaces.saudi_arabia]: {
    conditionsOfUse: 'https://www.amazon.sa/-/en/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.sa/-/en/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.sa/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.sa/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.sa/help/hub/reference/G201190440',
  },
  [Marketplaces.singapore]: {
    conditionsOfUse: 'https://www.amazon.sg/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.sg/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
    programPolicies: 'https://sellercentral.amazon.sg/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.sg/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.mx/help/hub/reference/G201190440',
  },
  [Marketplaces.spain]: {
    conditionsOfUse: 'https://www.amazon.es/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.es/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.es/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.es/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.es/help/hub/reference/G201190440',
  },
  [Marketplaces.sweden]: {
    conditionsOfUse: 'https://www.amazon.se/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.se/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.se/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.se/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.se/help/hub/reference/G201190440',
  },
  [Marketplaces.turkey]: {
    conditionsOfUse: 'https://www.amazon.com.tr/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.com.tr/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.com.tr/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com.tr/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.com.tr/help/hub/reference/G201190440',
  },
  [Marketplaces.uae]: {
    conditionsOfUse: 'https://www.amazon.ae/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.ae/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy',
    programPolicies: 'https://sellercentral.amazon.ae/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.ae/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.ae/help/hub/reference/G201190440',
  },
  [Marketplaces.uk]: {
    conditionsOfUse: 'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou',
    privacyNotice: 'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=201489330',
    programPolicies: 'https://sellercentral.amazon.co.uk/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.co.uk/help/hub/reference/G1801',
    agreement: 'https://sellercentral.amazon.co.uk/help/hub/reference/G201190440',
  },
  [Marketplaces.usa]: {
    conditionsOfUse: 'https://www.amazon.com/gp/help/customer/display.html?nodeId=GLSBYFE9MGKKQXXM',
    privacyNotice: 'https://www.amazon.com/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ&language=en_US',
    programPolicies: 'https://sellercentral.amazon.com/help/hub/reference/521',
    conduct: 'https://sellercentral.amazon.com/gp/help/external/G1801',
    agreement: 'https://sellercentral.amazon.com/gp/help/external/G1791',
  },
};
